import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { RoleComparePage } from '@/features/admin';

export const Route = createFileRoute('/_app/admin/roles/compare')({
  staticData: { crumb: 'admin:roles.compare' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.roles', 'Setup'),
  component: RoleComparePage,
});
